import { render } from "./P098.vue?vue&type=template&id=2e129f03&scoped=true"
import script from "./P098.vue?vue&type=script&lang=js"
export * from "./P098.vue?vue&type=script&lang=js"

import "./P098.vue?vue&type=style&index=0&id=2e129f03&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e129f03"]])

export default __exports__